import React, { useState, useEffect } from 'react'
import { Button, Row, Col, ListGroup, Image, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import CheckoutSteps from '../components/CheckoutSteps'
import { createOrder, createStripePaymentIntent, getStripePublishableKey, getShippingCost } from '../actions/orderActions'
import { ORDER_CREATE_RESET } from '../constants/orderConstants'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import StripePaymentForm from '../components/StripePaymentForm'

function PlaceOrderScreen({ history }) {

    const orderCreate = useSelector(state => state.orderCreate)
    const { order, error, success } = orderCreate

    const dispatch = useDispatch()

    const cart = useSelector(state => state.cart)

    const shippingCostState = useSelector(state => state.shippingCost)
    const { shippingRates } = shippingCostState

    cart.itemsPrice = cart.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0).toFixed(2)

    let calculatedShippingPrice = 0
    if (shippingRates && cart.shippingAddress.country) {
        const rate = shippingRates.find(r => r.country === cart.shippingAddress.country)
        calculatedShippingPrice = rate ? rate.cost : 0
    }
    cart.shippingPrice = Number(calculatedShippingPrice).toFixed(2)

    cart.taxPrice = Number(0).toFixed(2)

    cart.totalPrice = (Number(cart.itemsPrice) + Number(cart.shippingPrice) + Number(cart.taxPrice)).toFixed(2)


    if (!cart.paymentMethod) {
        history.push('/payment')
    }

    const stripePublishableKey = useSelector(state => state.stripePublishableKey)
    const { publishableKey } = stripePublishableKey

    const stripePaymentIntent = useSelector(state => state.stripePaymentIntent)
    const { clientSecret } = stripePaymentIntent

    const [stripePromise, setStripePromise] = useState(null)

    useEffect(() => {
        dispatch(getStripePublishableKey())
        dispatch(getShippingCost())
    }, [dispatch])

    useEffect(() => {
        console.log('PlaceOrderScreen - publishableKey:', publishableKey);
        if (publishableKey) {
            setStripePromise(loadStripe(publishableKey))
        }
    }, [publishableKey])

    useEffect(() => {
        if (cart.totalPrice && !clientSecret) {
            dispatch(createStripePaymentIntent(cart.totalPrice))
        }
    }, [dispatch, cart.totalPrice, clientSecret, stripePromise])

    return (
        <div>
            <CheckoutSteps step1 step2 step3 step4 />
            <Row>
                <Col md={8}>
                    <ListGroup variant='flush'>
                        <ListGroup.Item>
                            <h2>Shipping</h2>

                            <p>
                                <strong>Shipping: </strong>
                                {cart.shippingAddress.address},  {cart.shippingAddress.city}
                                {'  '}
                                {cart.shippingAddress.postalCode},
                                {'  '}
                                {cart.shippingAddress.country}
                            </p>
                        </ListGroup.Item>

                        <ListGroup.Item>
                            <h2>Payment Method</h2>
                            <p>
                                <strong>Method: </strong>
                                {cart.paymentMethod}
                            </p>
                            {cart.paymentMethod === 'Stripe' && (
                                <Message variant='info'>Payments processed securely by Stripe.</Message>
                            )}
                        </ListGroup.Item>

                        <ListGroup.Item>
                            <h2>Order Items</h2>
                            {cart.cartItems.length === 0 ? <Message variant='info'>
                                Your cart is empty
                            </Message> : (
                                    <ListGroup variant='flush'>
                                        {cart.cartItems.map((item, index) => (
                                            <ListGroup.Item key={index}>
                                                <Row>
                                                    <Col md={1}>
                                                        <Image src={item.image} alt={item.name} fluid rounded />
                                                    </Col>

                                                    <Col>
                                                        <Link to={`/product/${item.product}`}>{item.name}</Link>
                                                    </Col>

                                                    <Col md={4}>
                                                        {item.qty} X €{item.price} = €{(item.qty * item.price).toFixed(2)}
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                )}
                        </ListGroup.Item>

                    </ListGroup>

                </Col>

                <Col md={4}>
                    <Card>
                        <ListGroup variant='flush'>
                            <ListGroup.Item>
                                <h2>Order Summary</h2>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <Row>
                                    <Col>Items:</Col>
                                    <Col>€{cart.itemsPrice}</Col>
                                </Row>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <Row>
                                    <Col>Shipping:</Col>
                                    <Col>€{cart.shippingPrice}</Col>
                                </Row>
                            </ListGroup.Item>

                            <ListGroup.Item>
                                <Row>
                                    <Col>Total:</Col>
                                    <Col>€{cart.totalPrice}</Col>
                                </Row>
                            </ListGroup.Item>


                            <ListGroup.Item>
                                {error && <Message variant='danger'>{error}</Message>}
                            </ListGroup.Item>

                            <ListGroup.Item>
                                {clientSecret && stripePromise && (
                                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                                        <StripePaymentForm history={history} clientSecret={clientSecret} />
                                    </Elements>
                                )}
                                <p className="mt-3 text-center text-muted">
                                    Your payment is securely processed by Stripe. We do not store your card details.
                                    Learn more about Stripe's security practices <a href="https://stripe.com/docs/security" target="_blank" rel="noopener noreferrer">here</a>.
                                </p>
                            </ListGroup.Item>

                        </ListGroup>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default PlaceOrderScreen
